"use strict";

import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.find.js";
var _require = require("luxon"),
  DateTime = _require.DateTime;
import wNumb from "wnumb";
var Choices = require("choices.js");
function setFormType(type) {
  document.querySelectorAll(".search-filter").forEach(function (elt) {
    elt.style.display = elt.classList.contains("search-filter-for-" + type) ? "block" : "none";
  });
  document.querySelector("#search_form").className = "form-" + type;
}
document.getElementById("search_type").addEventListener("change", function (e) {
  setFormType(e.target.value);
});
setFormType(document.getElementById("search_type").value);
if (document.getElementById("search_order_select")) document.getElementById("search_order_select").addEventListener("change", function (e) {
  document.getElementById("search_order_value").value = e.target.value;
  document.getElementById("search_form").submit();
});
if (document.getElementById("search_form")) {
  document.getElementById("search_form").addEventListener('submit', function (e) {
    e.preventDefault();
    if (document.getElementById("search_keyword").value.length == 0) {
      document.getElementById("search_keyword").value = 'none';
    }
    document.getElementById("search_form").submit();
  });
}
var element = document.querySelector(".search-signature");
var choices = new Choices(element, {
  placeholder: true,
  placeholderValue: "Rechercher un auteur...",
  maxItemCount: 5,
  loadingText: "Chargement...",
  noResultsText: "Aucun auteur trouvé",
  noChoicesText: "Aucune proposition...",
  itemSelectText: "",
  removeItemButton: true
}).setChoices(function () {
  return fetch("/wp-admin/admin-ajax.php?action=search_signatures", {
    method: "POST"
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data.signatures.map(function (signature) {
      return {
        value: signature.term_id,
        label: signature.name
      };
    });
  });
});
["start", "end"].forEach(function (name) {
  // define variables
  var nativePicker = document.querySelector("." + name + "-nativeDatePicker");
  var fallbackPicker = document.querySelector("." + name + "-fallbackDatePicker");
  var fallbackLabel = document.querySelector("." + name + "-fallbackLabel");

  // hide fallback initially
  fallbackPicker.style.display = "none";
  fallbackLabel.style.display = "none";

  // test whether a new date input falls back to a text input or not
  var test = document.createElement("input");
  try {
    test.type = "month";
  } catch (e) {
    console.log(e.description);
  }

  // if it does, run the code inside the if() {} block
  if (test.type === "text") {
    // hide the native picker and show the fallback
    nativePicker.style.display = "none";
    fallbackPicker.style.display = "block";
    fallbackLabel.style.display = "block";
    var yearSelect = document.querySelector("#" + name + "-year");
    var monthSelect = document.querySelector("#" + name + "-month");

    // populate the years dynamically
    // (the months are always the same, therefore hardcoded)
    populateYears();
    yearSelect.addEventListener("change", function (e) {
      updateMonthInputs();
    });
  }
  function updateMonthInputs() {
    ["start", "end"].forEach(function (name) {
      document.querySelector("#" + name).value = document.querySelector("#" + name + "-year").value + "-" + document.querySelector("#" + name + "-month").value;
    });
  }
  function populateYears() {
    // get the current year as a number
    var date = new Date();
    var year = date.getFullYear();

    // Make this year, and the 100 years before it available in the year <select>
    for (var i = 0; i <= 30; i++) {
      var option = document.createElement("option");
      option.textContent = year - i;
      yearSelect.appendChild(option);
    }
  }
});
jQuery(function () {
  document.querySelectorAll(".search-results-tabs li:not(.search-type-current) a").forEach(function (elt) {
    if (!elt.href.match(/#$/)) {
      jQuery.getJSON(elt.href, function (data) {
        var span = document.createElement("span");
        span.innerHTML = "(" + data.found_posts + ")";
        document.querySelector(".search-results-tabs .search-type-" + data["search-type"] + " a").appendChild(span);
        if (data.found_posts == 0) {
          document.querySelector(".search-results-tabs .search-type-" + data["search-type"]).classList.add("no-results");
        }
        if (document.querySelector(".alternative-search") && data.found_posts) {
          document.querySelector(".alternative-search .search-type-" + data["search-type"]).classList.add("results-found");
          var span_alt = document.createElement("span");
          span_alt.innerHTML = "(" + data.found_posts + ")";
          document.querySelector(".alternative-search .search-type-" + data["search-type"] + " a").appendChild(span_alt);
          document.querySelector(".alternative-search").classList.add("results-found");
          if (document.querySelector(".alternative-no-results")) {
            document.querySelector(".alternative-no-results").remove();
          }
        }
        document.querySelector(".results-count strong").textContent = parseInt(document.querySelector(".results-count strong").textContent) + data.found_posts;
      });
    }
  });

  // ProductCat Selects
  document.querySelectorAll('.search-filter.parentof').forEach(function (elt) {
    var parent = elt.querySelector('select');
    var child = document.querySelector('#' + elt.classList.value.match(/parentof-([\-\_\w]+)/)[1]);
    if (parent.value) {
      child.querySelectorAll('option[class^="childof-"]').forEach(function (option) {
        option.style.display = option.classList.contains('childof-' + parent.value) ? 'block' : 'none';
        // option.selected = '';
      });
    } else {
      child.querySelectorAll('option').forEach(function (option) {
        option.style.display = 'none';
        option.selected = '';
      });
    }
    parent.addEventListener('change', function (e) {
      child.querySelectorAll('option:checked').forEach(function (option) {
        option.selected = '';
      });
      child.querySelectorAll('option[class^="childof-"]').forEach(function (option) {
        option.style.display = option.classList.contains('childof-' + parent.value) ? 'block' : 'none';
      });
      child.querySelector('option').selected = 'selected';
      if (parent.value == 3288) {
        document.querySelectorAll('.search-filter-product_cat')[1].style.display = 'none';
        document.querySelector('.search-filter-publication').style.display = 'block';
      } else {
        document.querySelectorAll('.search-filter-product_cat')[1].style.display = 'block';
        document.querySelector('.search-filter-publication').style.display = 'none';
      }
    });
  });
  if (document.querySelector('.search-filter-product_cat select').value) {
    if (document.querySelector('.search-filter-product_cat select').value == 3288) {
      document.querySelectorAll('.search-filter-product_cat')[1].style.display = 'none';
      document.querySelector('.search-filter-publication').style.display = 'block';
    } else {
      document.querySelectorAll('.search-filter-product_cat')[1].style.display = 'block';
      document.querySelector('.search-filter-publication').style.display = 'none';
    }
  }
});
var toggleBlock = function toggleBlock() {
  jQuery(document).on("click", ".search-block__sidebar .search-filter .js-toggle-title", function (event) {
    jQuery(this).parents(".search-filter").find(".js-toggle-content").stop().slideToggle(400, function () {
      if (jQuery(this).is(":visible")) {
        jQuery(this).parents(".search-filter").find(".js-toggle-title").addClass("active");
      } else {
        jQuery(this).parents(".search-filter").find(".js-toggle-title").removeClass("active");
      }
    });
    jQuery(this).parents(".search-filter").removeClass("active");
    event.preventDefault();
  });
  if (window.matchMedia("(max-width: 992px)").matches) {
    jQuery(document).on("click", ".js-toggle-advanced-search-title", function (event) {
      jQuery(this).toggleClass("active");
      jQuery(".search-block__inner--advanced-sidebar").stop().slideToggle();
      event.preventDefault();
    });
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
    var $search_results_tabs = jQuery(".search-results-tabs__list");
    if ($search_results_tabs.length) {
      if (jQuery(".search-type-current").length) {
        if (jQuery(".search-type-current").index() != 0) {
          jQuery(".search-results-tabs").addClass("search-results-tabs--scroll");
        }
        $search_results_tabs.animate({
          scrollLeft: $search_results_tabs.find(".search-type-current").offset().left - 24
        }, 400);
      }
    }
  }
};

// DOCUMENT READY
jQuery(document).ready(function () {
  toggleBlock();
});

// RESIZE
jQuery(window).on("resize", function () {
  toggleBlock();
});